'use client';

export function calculateBrowserWidth(): number {
  return window.innerWidth && document.documentElement.clientWidth
    ? Math.min(window.innerWidth, document.documentElement.clientWidth)
    : window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
}

export function isSubscribePage() {
  return ['/subscribe/', '/paid-subscribe/', '/email-subscribe/'].some((path) =>
    window.location.pathname.includes(path),
  );
}
